/**
 * Oscilación horizontal de las barras móviles (lógica pura, sin Phaser).
 *
 * `Board`/`PourController` llaman a esta función en cada tick para
 * reposicionar el cuerpo físico de una barra `moving`, en vez de calcular
 * la trigonometría directamente en la capa de render.
 */

import type { BarMovingDef } from '../../core/types';

/**
 * Posición horizontal (fracción 0..1 del ancho del tablero) de una barra
 * móvil en un instante dado, como oscilación senoidal suave alrededor de su
 * posición de reposo `baseX`. El resultado se recorta a [0, 1] para que la
 * barra nunca termine fuera del tablero.
 */
export function movingBarOffsetX(baseX: number, elapsedMs: number, moving: BarMovingDef): number {
  const wave = Math.sin((elapsedMs / 1000) * moving.speed);
  const x = baseX + wave * moving.range;
  return Math.min(1, Math.max(0, x));
}
